import {
  TrackerStaticText,
  TriggerLoginModal
} from '../../header/login/login.interface';
import { ContentAuxiliaryNavigation } from './contentauxiliarynavigation.model';
import { ContentMainNavigation } from './contentmainnavigation.model';
import { ContentModelPopup, ContentPageTitle } from './contentModelPopup.model';
import { ContentPrimaryNavigation } from './contentprimarynavigation.model';
import { ContentRightNav } from './contentrightnav.model';
import { ContentSearchFeed } from './contentsearchfeed.model';
import { ContentSecondaryNavigation } from './contentsecondarynavigation.model';

export class ContentHeader {
  headerNavigation: ContentHeaderNavigation;
  rightnav: ContentRightNav;
  searchfeed: ContentSearchFeed;
  disableBusinessHomePage: any;
  enableMilesNewProfileSelector: boolean;
  title: ContentPageTitle;
  enableWidgetExpandar: boolean;
  enableNewProfileSelector: boolean;
  triggerLoginModal: TriggerLoginModal[] | [];
  primaryNavigations: Map<string, ContentPrimaryNavigation>;
  secondaryNavigation: Map<string, ContentSecondaryNavigation>;
  auxiliaryNavigation: Map<string, ContentAuxiliaryNavigation>;
  modelPopups: Map<string, ContentModelPopup>;
  trackerStaticText: TrackerStaticText;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['primaryNavigation']) {
        this.primaryNavigations = this.fillPrimaryNavigation(
          contentjson['primaryNavigation']
        );
      }
      if (contentjson['secondaryNavigation']) {
        this.secondaryNavigation = this.fillSecondaryNavigation(
          contentjson['secondaryNavigation']
        );
      }
      if (contentjson['auxiliaryNavigation']) {
        this.auxiliaryNavigation = this.fillAuxiliaryNavigation(
          contentjson['auxiliaryNavigation']
        );
      }
      if (contentjson['modelPopUps']) {
        this.modelPopups = this.fillModelPopups(contentjson['modelPopUps']);
      }
      if (contentjson['disableBusinessHomePage']) {
        this.disableBusinessHomePage = contentjson['disableBusinessHomePage'];
      }
      if (contentjson['title']) {
        this.title = contentjson['title'];
      }
      if (contentjson['triggerLoginModal']) {
        this.triggerLoginModal = contentjson['triggerLoginModal'];
      } else {
        this.triggerLoginModal = [];
      }
      if (contentjson['trackerStaticText']) {
        this.trackerStaticText = contentjson['trackerStaticText'];
      } else {
        this.trackerStaticText = null;
      }
      if (contentjson['enableWidgetExpandar']) {
        const expandarFlag = contentjson['enableWidgetExpandar'];
        this.enableWidgetExpandar =
          expandarFlag === '' || expandarFlag.toLowerCase() === 'true'
            ? true
            : false;
      } else {
        this.enableWidgetExpandar = true;
      }
      if (contentjson['enableNewProfileSelector']) {
        const newProfileSelector = contentjson['enableNewProfileSelector'];
        this.enableNewProfileSelector =
          newProfileSelector === '' ||
          newProfileSelector.toLowerCase() === 'true'
            ? true
            : false;
      } else {
        this.enableNewProfileSelector = false;
      }
      if (contentjson['enableMilesNewProfileSelector']) {
        this.enableMilesNewProfileSelector =
          contentjson['enableMilesNewProfileSelector'];
      } else {
        this.enableMilesNewProfileSelector = false;
      }
    }
  }

  private fillPrimaryNavigation(contentjson?: any) {
    const primaryNavigation: Map<string, ContentPrimaryNavigation> = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      for (const value of values) {
        primaryNavigation.set(
          value['id'],
          new ContentPrimaryNavigation(value['id'], value)
        );
      }
    }

    return primaryNavigation;
  }

  private fillSecondaryNavigation(contentjson?: any) {
    const secondaryNavigation: Map<string, ContentSecondaryNavigation> =
      new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      for (const value of values) {
        secondaryNavigation.set(
          value['id'],
          new ContentSecondaryNavigation(value['id'], value)
        );
      }
    }

    return secondaryNavigation;
  }

  private fillAuxiliaryNavigation(contentjson?: any) {
    const auxiliaryNavigation: Map<string, ContentAuxiliaryNavigation> =
      new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      for (const value of values) {
        auxiliaryNavigation.set(
          value['id'],
          new ContentAuxiliaryNavigation(value['id'], value)
        );
      }
    }

    return auxiliaryNavigation;
  }

  private fillModelPopups(contentjson?: any) {
    const modelPopups: Map<string, ContentModelPopup> = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => {
        return contentjson[key];
      });
      for (const value of values) {
        modelPopups.set(
          value['modelId'],
          new ContentModelPopup(value['modelId'], value)
        );
      }
    }

    return modelPopups;
  }
}

export class ContentHeaderNavigation {
  mainNavigation: Map<string, ContentMainNavigation>;
  secondaryNavigation: Map<string, ContentSecondaryNavigation>;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['mainNavigation']) {
        this.fillContentMainNavigation(contentjson['mainNavigation']);
      }
      if (contentjson['secondaryNavigation']) {
        this.fillContentSecondaryNavigation(contentjson['secondaryNavigation']);
      }
    } else {
      this.fillContentMainNavigation();
      this.fillContentSecondaryNavigation();
    }
  }

  private fillContentMainNavigation(contentjson?: any) {
    this.mainNavigation = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      for (const value of values) {
        this.mainNavigation.set(
          value['id'],
          new ContentMainNavigation(value['id'], value)
        );
      }
    } else {
      this.mainNavigation.set(
        'my_trips',
        new ContentMainNavigation('my_trips')
      );
      this.mainNavigation.set(
        'check_in',
        new ContentMainNavigation('check_in')
      );
      this.mainNavigation.set(
        'flightstatus',
        new ContentMainNavigation('flightstatus')
      );
    }
  }

  private fillContentSecondaryNavigation(contentjson?: any) {
    this.secondaryNavigation = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      for (const value of values) {
        this.secondaryNavigation.set(
          value['id'],
          new ContentSecondaryNavigation(value, value['id'])
        );
      }
    } else {
      this.secondaryNavigation.set(
        'secondarynav',
        new ContentSecondaryNavigation(null, 'secondarynav')
      );
      this.secondaryNavigation.set(
        'sky-miles',
        new ContentSecondaryNavigation(null, 'sky-miles')
      );
      this.secondaryNavigation.set(
        'more',
        new ContentSecondaryNavigation(null, 'more')
      );
    }
  }
}
